import type { IconSvgObject } from './types';

const AudioWaveformIcon: IconSvgObject = [
  ["path", { d: "M2 13H3.34015C4.30258 13 5.12853 12.3145 5.30589 11.3686L6.31652 5.97856C6.42291 5.41116 6.91833 5 7.49561 5C8.0768 5 8.57439 5.41661 8.67656 5.98875L10.82 17.9921C10.9242 18.5753 11.4314 19 12.0239 19C12.5948 19 13.0898 18.6049 13.2163 18.0481L15.2706 9.0094C15.4048 8.41898 15.9297 8 16.5351 8C17.1078 8 17.6127 8.37564 17.7773 8.92417L18.5724 11.5747C18.8262 12.4207 19.6048 13 20.4881 13H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default AudioWaveformIcon;
